import { Navigate, useLocation } from 'react-router-dom';
import { isLoggedIn, getUser } from '../lib/auth';

export default function RequireAuth({ children, role }) {
  const location = useLocation();
  if (!isLoggedIn()) return <Navigate to="/login" state={{ from: location }} replace />;
  if (role && getUser()?.role !== role) return <Navigate to="/dashboard" replace />;
  return children;
}
